if (!customElements.get('cart-item')) {
  customElements.define(
    'cart-item',
    class CartItem extends window.BAO.CustomElement() {
      _loading = false
      sections = window.BAO.utils.sectionRenderer.cartSections

      setupListeners () {
        super.setupListeners()

        this.removeLineItem = this.removeLineItem.bind(this)
        this.changeLineItem = this.changeLineItem.bind(this)
        this.updateQuantity = this.updateQuantity.bind(this)

        if (this.els?.remove && this.els?.remove.exists) {
          this.listeners.add(
            this.els.remove.element,
            'click',
            this.removeLineItem,
          )
        }

        if (this.els?.variant && this.els?.variant.exists) {
          this.listeners.add(
            this.els.variant.element,
            'change',
            this.changeLineItem,
          )
        }

        if (this.els?.quantity.exists) {
          this.els.quantity.elements.forEach(quantityEl => {
            this.listeners.add(quantityEl, 'change', this.updateQuantity)
          })
        }
      }

      async removeLineItem () {
        this.setAttribute('aria-busy', 'true')

        const state = await window.BAO.Cart.removeItem(
          this.dataKey,
          this.sections.map(s => s.section),
        )

        if ('sections' in state) this.renderSections(state.sections)
      }

      async changeLineItem (event) {
        const id = event.target.value
        this.setAttribute('aria-busy', 'true')
        await window.BAO.Cart.addItem({ id, quantity: 1 }, null, {
          sections: ['push-cart-count'],
        })
        await this.removeLineItem()
      }

      async updateQuantity (e) {
        const state = await window.BAO.Cart.updateQuantity(
          this.dataKey,
          parseInt(e.currentTarget.value, 10),
          this.sections.map(s => s.section),
        )

        if ('sections' in state) this.renderSections(state.sections)
      }

      get loading () {
        return this._loading
      }

      set loading (val) {
        this._loading = val
      }

      get dataKey () {
        return this.dataset.key
      }
    },
  )
}
